import {makeStyles} from '@material-ui/core/styles';
import React from "react";


const useStyles = makeStyles(theme => ({
    root: {
        marginRight: 6,
    }
}));

export default function Label(props) {
    const classes = useStyles();

    return (
        <span
            className={classes.root}
        >
            {props.children}
        </span>
    );
};